module.exports = __webpack_public_path__ + "static/media/Screenshot_2.62d953f0.png";